function createHeroSwiperOptions(paginationElement, a11yMessages = {}) {
  return {
    loop: true,
    speed: 700,
    autoplay: {
      delay: 20000,
      disableOnInteraction: false
    },
    pagination: {
      el: paginationElement,
      clickable: true
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    a11y: a11yMessages,
    observer: true,
    observeParents: true
  }
}

function createStorySwiperOptions(previousElement, nextElement, isFourK = false) {
  return {
    loop: true,
    speed: 700,
    initialSlide: 1,
    slidesPerView: isFourK ? 3 : 'auto',
    centeredSlides: true,
    spaceBetween: 24,
    autoplay: {
      delay: 6500,
      disableOnInteraction: false
    },
    navigation: {
      prevEl: previousElement,
      nextEl: nextElement
    },
    observer: true,
    observeParents: true
  }
}

function getExhibitionNavigationState(containerRect, firstSlideRect, lastSlideRect, tolerance = 2) {
  return {
    canMovePrev: firstSlideRect.left < containerRect.left - tolerance,
    canMoveNext: lastSlideRect.right > containerRect.right + tolerance
  }
}

module.exports = {
  createHeroSwiperOptions,
  createStorySwiperOptions,
  getExhibitionNavigationState
}
